<template>
  <el-tabs v-model="active" type="border-card">
    <el-tab-pane label="正常区盘点日志" :name="constantMap.normal">
      <div v-loading.body="loading">
        <el-row class="filter">
          <el-col>
            <div
              style="
                background: #f3f3f3;
                height: 30px;
                line-height: 30px;
                padding: 0 25px;
                display: flex;
                align-items: center;
              "
            >
              <div>查询搜索</div>
              <el-button
                type="text"
                style="margin-left: auto"
                :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
                @click="toggleFilter"
                >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
              >
            </div>
            <el-collapse-transition>
              <div v-show="!filterFold">
                <div style="padding: 10px 25px">
                  <el-form
                    :inline="true"
                    :model="form"
                    class="demo-form-inline"
                  >
                    <el-form-item>
                      <el-select
                        v-model="search_type"
                        placeholder=""
                        style="width: 150px"
                      >
                        <el-option
                          v-for="item in search_options"
                          :key="item.key"
                          :label="item.name"
                          :value="item.key"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item style="margin-left: -15px; width: 165px">
                      <el-input
                        v-model="search_value"
                        placeholder="请输入搜索内容"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>

                    <el-form-item>
                      <el-select
                        v-model="form.area_type"
                        placeholder="盘点仓区"
                        filterable
                        style="width: 150px"
                      >
                        <el-option label="全部" value="0"></el-option>
                        <el-option
                          v-for="item in searchOptions.area_type"
                          :key="item.key"
                          :label="item.label"
                          :value="item.key"
                        ></el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item>
                      <el-select
                        v-model="form.inventory_type"
                        placeholder="盘点类型"
                        filterable
                        style="width: 150px"
                      >
                        <el-option label="全部" value="0"></el-option>
                        <el-option
                          v-for="item in searchOptions.inventory_type"
                          :key="item.key"
                          :label="item.label"
                          :value="item.key"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.inventory_model"
                        placeholder="盘点方式"
                        filterable
                        style="width: 150px"
                      >
                        <el-option label="全部" value="0"></el-option>
                        <el-option
                          v-for="item in searchOptions.inventory_model"
                          :key="item.key"
                          :label="item.label"
                          :value="item.key"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.is_moved"
                        placeholder="是否移位"
                        filterable
                        style="width: 150px"
                      >
                        <el-option label="全部" value="0"></el-option>
                        <el-option
                          v-for="item in searchOptions.is_moved"
                          :key="item.key"
                          :label="item.label"
                          :value="item.key"
                        ></el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="盘点时间：">
                      <el-date-picker
                        v-model="form.create_time"
                        type="datetimerange"
                        :default-time="['06:00:00', '06:00:00']"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                      >
                      </el-date-picker>
                    </el-form-item>

                    <el-form-item>
                      <el-button type="" @click="reset">重置</el-button>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" @click="search">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="success" @click="exportExcel">
                        导出</el-button
                      >
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </el-collapse-transition>
          </el-col>
        </el-row>
        <el-row>
          <el-col style="border: 1px solid #ddd">
            <div style="margin-bottom: 0">
              <el-table
                v-if="resData"
                ref="multipleTable"
                v-loading="tableLoading"
                height="800"
                :data="resData.list"
                tooltip-effect="dark"
                style="width: 100%"
                @selection-change="handleSelectionChange"
              >
                <el-table-column
                  align="center"
                  show-overflow-tooltip
                  prop="dbid"
                  label="打标id"
                  width="150"
                ></el-table-column>
                <el-table-column
                  align="center"
                  show-overflow-tooltip
                  prop="goods_name"
                  label="商品名称"
                  width="150"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="sku"
                  label="sku编号"
                ></el-table-column>
                <el-table-column align="center" label="颜色/尺码">
                  <template slot-scope="scope">
                    {{ scope.row.co_val }}/ {{ scope.row.si_val }}
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="inventory_no"
                  label="盘点单号"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="inventory_area_type"
                  label="盘点仓区"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="areas"
                  label="正常区区域"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="inventory_inventory_type"
                  label="盘点类型"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="inventory_inventory_model"
                  label="盘点方式"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="inventory_inventory_times"
                  label="盘点次数"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="admin_name"
                  label="盘点人"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="create_time"
                  label="盘点时间"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="inventory_space"
                  label="盘点仓位"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="init_space"
                  label="原仓位"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="inventory_log_is_moved"
                  label="是否移位"
                ></el-table-column>
              </el-table>
            </div>
            <div v-if="resData" style="text-align: right; padding: 25px">
              <el-pagination
                :current-page.sync="curPage"
                background
                layout="total, prev, pager, next, jumper ,sizes"
                :total="resData.count"
                :page-size="form.pagesize"
                :page-sizes="[50, 100, 200, 500, 1000]"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
              >
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-tab-pane>
    <el-tab-pane label="次品区盘点日志" :name="constantMap.defective">
      <YsDataTable
        :refresh="refreshDefective"
        :list="searchListDefective"
        :button-list="buttonListDefective"
        :fetch-method="fetchMethodDefective"
        :columns="columnsDefective"
        :transform-params="handleFormatSearch"
        use-data-field
        page-size-alias="page_size"
        @on-change="handleParamsChange"
      >
        <template #feature="{ row }">
          <span>{{ row.co_val }}/{{ row.si_val }}</span>
        </template>
      </YsDataTable>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import dayjs from "dayjs";
import apiBaseURL from "@/utils/baseUrl.js";
import * as defectiveInventoryApi from "@/controller/defectiveInventory3634.js";
import { openDownloadWindow } from "@/utils/export.js";

const constantMap = Object.freeze({
  normal: "0",
  defective: "1",
  optionsType: [
    { value: "dbid", label: "打标id" },
    { value: "inventory_dp_no", label: "盘点单号" },
    { value: "sku", label: "sku" },
  ],
  optionsMove: [
    { label: "全部", value: "0" },
    { label: "是", value: "1" },
    { label: "否", value: "2" },
  ],
  dayGap: 31,
});
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchCondition();
      vm.handleInit();
    });
  },
  data() {
    return {
      constantMap,
      images: [],
      showbox: false,
      fileList: [],
      resData: {},
      form: {
        pagesize: 50,
        create_time: this.defaultDate(),
      },
      search_type: "dbid",
      search_options: [
        { key: "dbid", name: "打标id" },
        { key: "inventory_no", name: "盘点单号" },
        { key: "sku", name: "sku" },
      ],
      search_value: "",
      origin: 1,
      space: "",
      ss_id: 0,
      loading: false,
      tableLoading: false,
      url: "/erp/Inventory/inventoryLog",
      curPage: 1,
      filterFold: false,
      isAll: false,
      searchOptions: {},
      active: constantMap.normal,
      // 次品部分
      refreshDefective: false,
      fetchMethodDefective: defectiveInventoryApi.dpInventoryLog,
      searchListDefective: [
        {
          tag: "select",
          label: "",
          field: "searchType",
          defaultValue: "inventory_dp_no",
          options: constantMap.optionsType,
        },
        {
          tag: "input",
          label: "",
          field: "searchValue",
        },
        {
          tag: "select",
          label: "是否移位",
          field: "is_moved",
          options: constantMap.optionsMove,
        },
        {
          tag: "date",
          label: "盘点时间",
          field: "create_time",
          defaultValue: [
            dayjs()
              .subtract(constantMap.dayGap, "day")
              .format("YYYY-MM-DD 06:00:00"),
            dayjs().format("YYYY-MM-DD 06:00:00"),
          ],
          props: {
            type: "datetimerange",
            defaultTime: ["06:00:00", "06:00:00"],
            "value-format": "yyyy-MM-dd HH:mm:ss",
            format: "yyyy-MM-dd HH:mm:ss",
          },
          transform: (value = []) => {
            if (value) {
              return {
                create_time:
                  value?.map((v) => dayjs(v).format("YYYY-MM-DD HH:mm:ss")) ||
                  [],
              };
            }
            return {
              create_time: [],
            };
          },
        },
      ],
      buttonListDefective: [
        {
          tag: "button",
          text: "导出",
          props: {
            type: "success",
          },
          event: {
            handler: this.handleExportExcelList,
          },
        },
      ],
      columnsDefective: [
        {
          label: "打标ID",
          prop: "dbid",
        },
        {
          label: "商品名称",
          prop: "goods_name",
          "show-overflow-tooltip": true,
        },
        {
          label: "sku编号",
          prop: "sku",
        },
        {
          label: "颜色/尺码",
          slot: "feature",
        },
        {
          label: "盘点单号",
          prop: "inventory_dp_no",
        },
        {
          label: "盘点仓区",
          prop: "inventory_area_type",
        },
        {
          label: "盘点类型",
          prop: "inventory_type",
        },
        {
          label: "盘点方式",
          prop: "inventory_model",
        },
        {
          label: "盘点次数",
          prop: "inventory_times_str",
        },
        {
          label: "盘点人",
          prop: "create_name",
        },
        {
          label: "盘点时间",
          prop: "created_at",
        },
        {
          label: "盘点包裹号",
          prop: "inventory_package_no",
        },
        {
          label: "原导入包裹号",
          prop: "source_inventory_package_no",
        },
        {
          label: "是否移位",
          prop: "is_moved_str",
        },
        {
          label: "打标ID状态",
          prop: "stock_detail_sj_status_str",
        },
      ],
      searchParamsDefective: {},
    };
  },
  computed: {
    filteredForm() {
      // eslint-disable-next-line no-restricted-syntax
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  mounted() {
    const { type, inventory_dp_no: inventoryDpNo } = this.$route.query;
    if (type === constantMap.defective) {
      if (inventoryDpNo) {
        this.searchListDefective.forEach((item) => {
          if (item.field === "searchType") {
            // eslint-disable-next-line no-param-reassign
            item.defaultValue = "inventory_dp_no";
          } else if (item.field === "searchValue") {
            // eslint-disable-next-line no-param-reassign
            item.defaultValue = inventoryDpNo;
          }
        });
      }
      this.active = type;
    }
  },
  methods: {
    defaultDate() {
      return this.$excalibur.getDateTimeOnHours(-2, 6);
    },
    exportExcel() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          window.open(apiBaseURL + res.data.data.file);
        }
      });
    },
    fetchCondition() {
      this.$http
        .post("/erp/Inventory/getCondition", this.filteredForm)
        .then((res) => {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.searchOptions = res.data.data;
            this.origin = res.data.data.origin;
          }
        });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      if (this.search_value !== "") {
        // eslint-disable-next-line guard-for-in,no-restricted-syntax
        for (const key in this.search_options) {
          this.form[this.search_options[key].key] = "";
        }
        this.form[this.search_type] = this.search_value;
      } else {
        // eslint-disable-next-line guard-for-in,no-restricted-syntax
        for (const key in this.search_options) {
          this.form[this.search_options[key].key] = "";
        }
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          console.log(this.resData);
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      const claimsDetailId = [];
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const key in val) {
        multipleSelection[key] = val[key].work_id;
        if (val[key].claims_detail_id) {
          claimsDetailId[key] = val[key].claims_detail_id;
        }
      }
      this.multipleSelection = multipleSelection;
      this.claims_detail_id = claimsDetailId;
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleSizeChange(val) {
      this.form.pagesize = val;
      this.fetchData(true);
    },

    search() {
      this.form.page = 1;
      this.loading = true;
      this.fetchData(true);
    },

    trim(str, isGlobal) {
      let result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (isGlobal.toLowerCase() === "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
    reset() {
      this.search_value = "";
      this.form = {};
      this.form.page = 1;
      this.form.pagesize = 50;
    },
    handleInit() {
      const {
        type,
        inventory_dp_no: inventoryDpNo,
        inventory_no: inventoryNo,
      } = this.$route.query;
      if (type === constantMap.normal) {
        this.active = type;
        if (inventoryNo) {
          this.search_type = "inventory_no";
          this.search_value = inventoryNo;
          this.fetchData(true);
        }
      } else if (type === constantMap.defective) {
        if (inventoryDpNo) {
          this.searchListDefective = this.searchListDefective.map((item) => {
            if (item.field === "searchType") {
              return {
                ...item,
                defaultValue: "inventory_dp_no",
              };
            }
            if (item.field === "searchValue") {
              return {
                ...item,
                defaultValue: inventoryDpNo,
              };
            }
            return item;
          });
        }
        this.active = type;
        this.refresh = true;
      }
    },
    handleFormatSearch(params) {
      const { searchType, searchValue, ...rest } = params;
      return {
        ...rest,
        [searchType]: searchValue,
      };
    },
    handleParamsChange(params) {
      this.searchParamsDefective = this.handleFormatSearch(params);
    },
    handleExportExcelList() {
      defectiveInventoryApi
        .dpInventoryLog({ ...this.searchParamsDefective, is_excel: "1" })
        .then(openDownloadWindow)
        .catch(this.$noop);
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/inventory/InventoryLog.vue